import { useState } from 'react';
import { addItem, removeItem, moveItem } from '../utils/listOps';

// Editable ordered list — add, delete, reorder (▲/▼). `items` is a string[];
// `onChange(next)` receives the new ordered array. Used for Settings reason
// codes (T-U3-010). Logic lives in utils/listOps (unit-tested).
export default function ListEditor({ items = [], onChange, placeholder = 'Add…' }) {
  const [draft, setDraft] = useState('');
  const add = () => { const next = addItem(items, draft); if (next !== items) { onChange(next); setDraft(''); } };
  return (
    <div className="list-editor">
      {items.map((it, i) => (
        <div key={`${it}-${i}`} className="list-row">
          <span className="list-label">{it}</span>
          <button type="button" className="btn btn-ghost btn-sm" onClick={() => onChange(moveItem(items, i, -1))} disabled={i === 0} aria-label="Move up">▲</button>
          <button type="button" className="btn btn-ghost btn-sm" onClick={() => onChange(moveItem(items, i, 1))} disabled={i === items.length - 1} aria-label="Move down">▼</button>
          <button type="button" className="btn btn-ghost btn-sm" onClick={() => onChange(removeItem(items, i))} aria-label="Remove">✕</button>
        </div>
      ))}
      <div className="row" style={{ gap: 6, marginTop: 6 }}>
        <input
          className="input"
          value={draft}
          placeholder={placeholder}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); add(); } }}
        />
        <button type="button" className="btn btn-ghost btn-sm" onClick={add}>Add</button>
      </div>
    </div>
  );
}
